

























































































import { Component, Ref, Vue } from "vue-property-decorator";
import { loginForm } from "./types";
import { FormValidator } from "@/utils/formValidator";
import { ApiLogin } from "@/api/login/index";
import { UserModule } from "@/store/modules/user";
import { Form } from "element-ui/types";
import Cookies from "js-cookie";
@Component({ name: "login" })
export default class extends Vue {
  // 登录表单数据
  public loginFormData: loginForm = {
    username: "",
    password: "",
    grant_type: "password",
    client_id: "web",
    client_secret: "yeker_coconut",
  };
  /**
   * 验证器
   */
  public FormValidator = FormValidator;
  /**
   * 密码框是否睁开眼
   */
  public hasOpenEye = false;
  /**
   * 登录按钮是否需要loding
   */
  public loading = false;
  /**
   * 表单的ref
   */
  @Ref() readonly loginFormRef!: Form;
  /**
   * 刷新验证组件的key
   */
  public loginValidateKey: string = Date.now().toString();
  checked = false;
  userInfo: any;

  rules = {
    username: [
      { required: true, message: "必填", trigger: "blur" },
      {
        pattern: /^1(3\d|4\d|5\d|6[02567]|7[0-8]|8\d|9[0-3,5-9])\d{8}$/,
        message: "请输入正确的手机号",
        trigger: "change",
      },
    ],
    password: [
      { required: true, message: "必填", trigger: "blur" },
      {
        min: 6,
        max: 12,
        message: "请输入6-12位密码,包含字母、符号、数字",
        trigger: "change",
      },
    ],
  };
  /**
   * 登录
   */
  public login() {
    this.loginFormRef.validate(async (valide: boolean) => {
      // this.loading = true;
      if (valide) {
        // 登录获取数据
        const result = await ApiLogin(this.loginFormData);
        const Auth = `${result.data.data.token_type}${result.data.data.access_token}`;
        UserModule.setToken(Auth);
        Cookies.set("UserInfo", JSON.stringify(this.loginFormData));
        // UserModule.setUserData(this.loginFormData);
        // let resp: AxiosResponse<ILoginRes> = await ApiLogin(this.loginFormData);
        // // 存入token 和 用户data 的数据
        // UserModule.setToken(resp.data.token);
        // UserModule.setUserData(resp.data.data);

        // // 获取用户菜单
        // let menuRes = await APIGetMenu({
        //   phone: resp.data.data.mobile,
        //   comcode: resp.data.data.comcode,
        // });
        // console.log(menuRes);

        // this.$router.push("/");
        process.env.NODE_ENV === "development"
          ? (window.location.href = "http://192.168.0.21:8888/index.html")
          : (window.location.href = window.location.origin + "/index.html");
        this.loading = false;
      } else {
        this.$message.warning("请输入账号、密码");
        this.loginValidateKey = Date.now().toString();
        this.loading = false;
      }
    });
  }

  // 自动登录
  autoLogin(value: any) {
    Cookies.set("status", JSON.stringify(value));
  }
  async forget() {
    this.$router.push("/reset");
  }
  mounted() {
    if (
      this.checked &&
      this.loginFormData.username &&
      this.loginFormData.password
    ) {
      // this.login();
    }
  }
  created() {
    this.userInfo = Cookies.get("UserInfo");
    this.userInfo = JSON.parse(this.userInfo);
    if (Cookies.get("status") == "true") {
      this.checked = true;
    }
    if (this.checked && this.userInfo) {
      this.loginFormData.username = this.userInfo.username;
      this.loginFormData.password = this.userInfo.password;
    }
  }
}
